// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/auth-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar-hide::-webkit-scrollbar {
  display: none !important;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

a {
  text-decoration: none !important;
}

.gm-style-iw-d.h3 {
  font-size: 18px !important;
  font-weight: 500 !important;
  margin-bottom: 3px !important;
}

.gm-style-iw-d.p {
  font-size: 16px;
  margin-bottom: 3px;
}

/* Global scrollbar styling */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  border-radius: 20px;
  cursor: pointer;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 20px;
  cursor: pointer;
}

::-webkit-scrollbar-thumb {
  background: #c5c5c5;
  border-radius: 20px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
  cursor: pointer;
}

/* For Firefox - needs to be applied to html and body */
* {
  scrollbar-width: thin;
  scrollbar-color: #909090 transparent;
}

.gm-ui-hover-effect {
  width: 50px !important;
  height: 40px !important;
}

/* .gm-style-iw-ch{
    padding-top: 0px !important;
  } */
.gm-style-iw-d {
  overflow: auto !important;
  max-height: fit-content !important;
}

.gm-style-iw-chr {
  position: absolute;
  right: 0;
}

.gm-style-iw {
  padding: 0px !important;
}

.sidebar-toggle-in {
  width: 16rem;
}

.sidebar-toggle-out {
  width: 5rem;
}

/* Media Queries */
/* Small devices (phones, less than 768px) */
@media (max-width: 767.98px) {
  /* Styles for small devices */
  .sidebar-toggle-in {
    width: 16rem;
  }
  .sidebar-toggle-out {
    width: 0rem;
  }
}
/* Medium devices (tablets, 768px to 1023.98px) */
@media (min-width: 768px) and (max-width: 1023.98px) {
  /* Styles for medium devices */
}
/* Large devices (desktops, 1024px to 1199.98px) */
@media (min-width: 1024px) and (max-width: 1199.98px) {
  /* Styles for large devices */
}
/* Extra large devices (large desktops, 1200px to 2499.98px) */
@media (min-width: 1200px) and (max-width: 2499.98px) {
  /* Styles for extra large devices */
}
/* Huge devices (very large desktops, 2500px and up) */
@media (min-width: 2500px) {
  /* Styles for huge devices */
}
@media (max-width: 440px) {
  .entries-table {
    width: 310px !important;
    overflow: auto !important;
  }
}
@media (max-width: 470px) {
  .entries-table {
    width: 372px;
    overflow: auto;
  }
}
/* Toggle Switch Styles */
.switch-checkbox {
  transition: 0.2s;
}
.switch-checkbox:checked {
  right: 0;
  border-color: #10B981;
}
.switch-checkbox:not(:checked) {
  left: 0;
  border-color: #9CA3AF;
}

.switch-label {
  transition: background-color 0.2s;
}

/* Auth Background */
.auth-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.custom-checkbox:checked {
  background-color: #A52A2A;
  border-color: #A52A2A;
}
.custom-checkbox:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.custom-checkbox:focus {
  outline: none;
}
.custom-checkbox:hover:not(:checked) {
  border-color: #9CA3AF;
}

.custom-radio {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.custom-radio:checked {
  border-color: #A52A2A;
}
.custom-radio:checked::after {
  content: "";
  position: absolute;
  left: 0px;
  top: -1px;
  width: 13px;
  height: 15px;
  border-radius: 50%;
  background-color: #A52A2A;
}
.custom-radio:focus {
  outline: none;
}
.custom-radio:hover:not(:checked) {
  border-color: #9CA3AF;
}

.app-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  font-size: 1.5rem;
  color: #333;
  background-color: #f5f5f5;
}
.app-loading::after {
  content: "";
  width: 30px;
  height: 30px;
  border: 4px solid #ccc;
  border-top-color: #333;
  border-radius: 50%;
  margin-left: 10px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.route-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  font-size: 1rem;
  color: #666;
}
.route-loading::after {
  content: "";
  width: 20px;
  height: 20px;
  border: 3px solid #eee;
  border-top-color: #666;
  border-radius: 50%;
  margin-left: 10px;
  animation: spin 1s linear infinite;
}

/* Remove number input spinners */
/* For Chrome, Safari, Edge, Opera */
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ;;AAEA,4CAAA;AACA;EACI,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;AACJ;;AAMA,6BAAA;AACA;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,uBAAA;EACA,mBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,mBAAA;EACA,wCAAA;EAAA,gCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,eAAA;AAHJ;;AAMA,uDAAA;AACA;EACI,qBAAA;EACA,oCAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,uBAAA;AAHJ;;AAMA;;KAAA;AAIA;EACI,yBAAA;EACA,kCAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,QAAA;AAJJ;;AAOA;EACI,uBAAA;AAJJ;;AAQA;EACI,YAAA;AALJ;;AAQA;EACI,WAAA;AALJ;;AAQA,kBAAA;AAEA,4CAAA;AACA;EACI,6BAAA;EAEA;IACI,YAAA;EAPN;EAUE;IACI,WAAA;EARN;AACF;AAaA,iDAAA;AACA;EACI,8BAAA;AAXJ;AAcA,kDAAA;AACA;EACI,6BAAA;AAZJ;AAeA,8DAAA;AACA;EACI,mCAAA;AAbJ;AAgBA,sDAAA;AACA;EACI,4BAAA;AAdJ;AAiBA;EACE;IACE,uBAAA;IACA,yBAAA;EAfF;AACF;AAiBA;EACE;IACE,YAAA;IACA,cAAA;EAfF;AACF;AAkBA,yBAAA;AACA;EACI,gBAAA;AAhBJ;AAiBI;EACI,QAAA;EACA,qBAAA;AAfR;AAiBI;EACI,OAAA;EACA,qBAAA;AAfR;;AAmBA;EACI,iCAAA;AAhBJ;;AAmBA,oBAAA;AACA;EACI,yDAAA;AAhBJ;;AAmBA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAhBJ;AAkBI;EACE,yBAAA;EACA,qBAAA;AAhBN;AAkBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AAhBR;AAoBI;EACE,aAAA;AAlBN;AAqBI;EACE,qBAAA;AAnBN;;AAuBA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AApBJ;AAsBI;EACE,qBAAA;AApBN;AAsBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AApBR;AAwBI;EACE,aAAA;AAtBN;AAyBI;EACE,qBAAA;AAvBN;;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AAzBF;AA2BE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;AAzBJ;;AA6BA;EACE;IACE,yBAAA;EA1BF;AACF;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AA5BF;AA8BE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;AA5BJ;;AAgCA,iCAAA;AACA,oCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AA7BF;;AAgCA,gBAAA;AACA;EACE,0BAAA;AA7BF","sourcesContent":[".scrollbar-hide::-webkit-scrollbar {\n    display: none !important;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.scrollbar-hide {\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n}\n\na {\n    text-decoration: none !important;\n}\n\n.gm-style-iw-d.h3 {\n    font-size: 18px !important;\n    font-weight: 500 !important;\n    margin-bottom: 3px !important;\n}\n\n.gm-style-iw-d.p {\n    font-size: 16px;\n    margin-bottom: 3px;\n\n}\n\n\n\n\n/* Global scrollbar styling */\n::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    border-radius: 20px;\n    cursor: pointer;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 20px;\n    cursor: pointer;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #c5c5c5;\n    border-radius: 20px;\n    transition: background 0.2s ease;\n    cursor: pointer;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #b4b4b4;\n    cursor: pointer;\n}\n\n/* For Firefox - needs to be applied to html and body */\n* {\n    scrollbar-width: thin;\n    scrollbar-color: #909090 transparent;\n}\n\n.gm-ui-hover-effect {\n    width: 50px !important;\n    height: 40px !important;\n}\n\n/* .gm-style-iw-ch{\n    padding-top: 0px !important;\n  } */\n\n.gm-style-iw-d {\n    overflow: auto !important;\n    max-height: fit-content !important;\n}\n\n.gm-style-iw-chr {\n    position: absolute;\n    right: 0;\n}\n\n.gm-style-iw {\n    padding: 0px !important;\n}\n\n\n.sidebar-toggle-in{\n    width: 16rem;\n}\n\n.sidebar-toggle-out{\n    width: 5rem;\n}\n\n/* Media Queries */\n\n/* Small devices (phones, less than 768px) */\n@media (max-width: 767.98px) {\n    /* Styles for small devices */\n\n    .sidebar-toggle-in{\n        width: 16rem;\n    }\n\n    .sidebar-toggle-out{\n        width: 0rem;\n    }\n\n\n}\n\n/* Medium devices (tablets, 768px to 1023.98px) */\n@media (min-width: 768px) and (max-width: 1023.98px) {\n    /* Styles for medium devices */\n}\n\n/* Large devices (desktops, 1024px to 1199.98px) */\n@media (min-width: 1024px) and (max-width: 1199.98px) {\n    /* Styles for large devices */\n}\n\n/* Extra large devices (large desktops, 1200px to 2499.98px) */\n@media (min-width: 1200px) and (max-width: 2499.98px) {\n    /* Styles for extra large devices */\n}\n\n/* Huge devices (very large desktops, 2500px and up) */\n@media (min-width: 2500px) {\n    /* Styles for huge devices */\n}\n\n@media (max-width: 440px) {\n  .entries-table {\n    width: 310px !important;\n    overflow: auto !important;\n  }\n}\n@media (max-width: 470px) {\n  .entries-table {\n    width: 372px;\n    overflow: auto;\n  }\n}\n\n/* Toggle Switch Styles */\n.switch-checkbox {\n    transition: 0.2s;\n    &:checked {\n        right: 0;\n        border-color: #10B981;\n    }\n    &:not(:checked) {\n        left: 0;\n        border-color: #9CA3AF;\n    }\n}\n\n.switch-label {\n    transition: background-color 0.2s;\n}\n\n/* Auth Background */\n.auth-background {\n    background-image: url('../../public/auth-bg.jpg');\n}\n\n.custom-checkbox {\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    border: 2px solid #d1d5db;\n    border-radius: 4px;\n    background-color: white;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    position: relative;\n  \n    &:checked {\n      background-color: #A52A2A;\n      border-color: #A52A2A;\n  \n      &::after {\n        content: '';\n        position: absolute;\n        left: 4px;\n        top: 1px;\n        width: 5px;\n        height: 9px;\n        border: solid white;\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n      }\n    }\n  \n    &:focus {\n      outline: none;\n    }\n\n    &:hover:not(:checked) {\n      border-color: #9CA3AF;\n    }\n  }\n\n.custom-radio {\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    border: 2px solid #d1d5db;\n    border-radius: 50%;\n    background-color: white;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    position: relative;\n  \n    &:checked {\n      border-color: #A52A2A;\n  \n      &::after {\n        content: '';\n        position: absolute;\n        left: 0px;\n        top: -1px;\n        width: 13px;\n        height: 15px;\n        border-radius: 50%;\n        background-color: #A52A2A;\n      }\n    }\n  \n    &:focus {\n      outline: none;\n    }\n\n    &:hover:not(:checked) {\n      border-color: #9CA3AF;\n    }\n  }\n\n// Loading state\n.app-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  font-size: 1.5rem;\n  color: #333;\n  background-color: #f5f5f5;\n  \n  &::after {\n    content: '';\n    width: 30px;\n    height: 30px;\n    border: 4px solid #ccc;\n    border-top-color: #333;\n    border-radius: 50%;\n    margin-left: 10px;\n    animation: spin 1s linear infinite;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Route loading state\n.route-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n  font-size: 1rem;\n  color: #666;\n  \n  &::after {\n    content: '';\n    width: 20px;\n    height: 20px;\n    border: 3px solid #eee;\n    border-top-color: #666;\n    border-radius: 50%;\n    margin-left: 10px;\n    animation: spin 1s linear infinite;\n  }\n}\n\n/* Remove number input spinners */\n/* For Chrome, Safari, Edge, Opera */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
